module.exports = __webpack_public_path__ + "static/media/six-in-a-row-logo.be9e78fc.png";